import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { DecimalConfigService } from 'app/services/decimal-config.service';

@Pipe({
  name: 'decimalFormat',
  standalone: true,
  pure: true,
})
export class DecimalFormatPipe implements PipeTransform {
  constructor(
    private configService: DecimalConfigService
  ) {}

  transform(value: number, overrideDecimals?: number): string | null {
    // Changing this to decimalPipe direct implementation using to avoid circular dependency
    const decimalPipe = new DecimalPipe('en-US');
    const decimals = overrideDecimals ?? this.configService.getDecimals();
    return decimalPipe.transform(value, `1.${decimals}-${decimals}`);
  }
}
